<template>
  <n-card class="equipment-card" :class="{ clickable: isClickable }">
    <v-row no-gutters justify="start" align="center" class="equipment-header">
      <div class="header-left">
        <div class="number">{{ equipment.number || `-` }}</div>
      </div>
      <v-col class="d-flex flex-column header-right">
        <div>
          <div class="description">
            <v-clamp autoresize :max-lines="1">
              {{ equipment.label }}
            </v-clamp>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-row no-gutters>
            <v-col class="site ellipsis mr-2">
              <v-icon small>business</v-icon>
              {{ equipment.site.name }}
            </v-col>
            <div class="address" v-if="equipment.$address.length">
              {{ equipment.$address }}
              <v-icon small>place</v-icon>
            </div>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters class="intervention-footer">
      <v-col class="footer-item client" v-if="isAggregatorUser">
        <div class="footer-item-title ellipsis">prestataire</div>
        <div class="footer-item-content ellipsis">{{ equipment.maker.name }}</div>
      </v-col>
      <v-col class="footer-item client" v-else>
        <div class="footer-item-title ellipsis">client</div>
        <div class="footer-item-content ellipsis">{{ equipment.client.name }}</div>
      </v-col>
      <v-col class="footer-item model">
        <div>
          <div class="footer-item-title ellipsis">modèle</div>
          <div class="footer-item-content ellipsis">{{ equipment.model || `-` }}</div>
        </div>
      </v-col>
      <v-col class="footer-item brand">
        <div>
          <div class="footer-item-title ellipsis">marque</div>
          <div class="footer-item-content ellipsis">{{ equipment.brand || `-` }}</div>
        </div>
      </v-col>
      <v-col class="footer-item serial-number">
        <div>
          <div class="footer-item-title ellipsis">numéro de série</div>
          <div class="footer-item-content ellipsis">{{ equipment.serialNumber || `-` }}</div>
        </div>
      </v-col>
    </v-row>
  </n-card>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: `EquipmentCard`,
  props: {
    value: {},
    clickable: {
      type: Boolean,
    },
  },
  data: () => ({
  }),
  computed: {
    ...mapState(`model/user`, [
      `isAggregatorUser`,
    ]),
    ...mapState(`model/client`, [
      `company`,
    ]),
    isClickable() {
      return this.clickable === true;
    },
    equipment() {
      const site = _.clone(this.value.site);
      site.address = site.address || ``;
      site.postalCode = site.postalCode || ``;
      site.city = site.city || ``;
      return {
        ...this.value,
        $address: _.trim(`${site.address} ${site.postalCode} ${site.city}`),
      };
    },
  },
  methods: {
  },
};
</script>

<style lang="scss">
.equipment-card {
  padding-top: 10px;
  .equipment-header {
    padding-bottom: 4px;
    border-bottom: 1px solid #E2E2E2;
  }
  .header-left {
    width: 160px;
    // padding-top: 6px;
    margin-right: 10px;
    .number {
      text-align: center;
      font-size: 0.9rem;
      font-weight: 500;
    }
  }
  .header-right {
    margin-right: 15px;
    min-height: 48px;
    .description {
      margin-right: 40px;
      text-align: left;
      font-size: 1.1rem;
      font-weight: 500;
      line-height: 1.5rem;
    }
    .address,
    .site {
      font-size: 0.8rem;
      text-align: left;
      .v-icon {
        margin-top: -4px;
        margin-right: 0px;
      }
    }
  }

  .equipment-footer {
    margin: 0px 1px 1px;
  }

  .footer-item {
    min-width: 0;
    text-align: left;
    margin: 0px;
    background-color: transparent !important;
    &, &.col {
      padding: 8px !important;
    }
    &:not(:first-of-type) {
      border-left: 1px solid #E2E2E2;
    }
    .footer-item-title {
      font-size: 0.8rem;
      color: #888;
    }
    .footer-item-content {
      font-weight: 500;
      color: #555;
    }
    // &.updated-at {
    //   min-width: 172px;
    // }
    // &.date {
    //   max-width: 130px;
    // }
  }
}
</style>
